// This file was auto-generated by Fern from our API Definition.
import { toJson } from "../core/json.js";
export class AgentaApiError extends Error {
    statusCode;
    body;
    rawResponse;
    cause;
    constructor({ message, statusCode, body, rawResponse, cause, }) {
        super(buildMessage({ message, statusCode, body }));
        Object.setPrototypeOf(this, new.target.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        this.name = this.constructor.name;
        this.statusCode = statusCode;
        this.body = body;
        this.rawResponse = rawResponse;
        if (cause != null) {
            this.cause = cause;
        }
    }
}
function buildMessage({ message, statusCode, body, }) {
    const lines = [];
    if (message != null) {
        lines.push(message);
    }
    if (statusCode != null) {
        lines.push(`Status code: ${statusCode.toString()}`);
    }
    if (body != null) {
        lines.push(`Body: ${toJson(body, undefined, 2)}`);
    }
    return lines.join("\n");
}
